import { clientFor, type PageQuery, type PageResult, type Status } from '@yc/api-client'

const api = clientFor('/wms/api')

export type LocationKind = 'shelf' | 'bulk' | 'staging' | 'dock'

export interface Location {
  id: number
  tenant_id: number
  warehouse_id: number
  code: string
  name: string
  zone: string
  kind: LocationKind
  status: Status
  created_at: string
  updated_at: string
}

export interface LocationInput {
  /** 0 表示用默认仓，由后端解析后落库 */
  warehouse_id: number
  code: string
  name: string
  zone: string
  kind: LocationKind
  status: Status
}

export interface LocationQuery extends PageQuery {
  keyword?: string
  warehouse?: number
  zone?: string
  kind?: string
  status?: string
}

/** 与后端 services/wms/internal/location 的字典保持一致，改一边必须改另一边 */
export const KIND_LABELS: Record<LocationKind, string> = {
  shelf: '货架位',
  bulk: '整托存储位',
  staging: '暂存区',
  dock: '月台',
}

export const STATUS_LABELS: Record<Status, string> = { active: '启用', disabled: '停用' }

export const listLocations = (q: LocationQuery): Promise<PageResult<Location>> =>
  api.get<PageResult<Location>>('/locations', { ...q })

export const createLocation = (input: LocationInput): Promise<Location> =>
  api.post<Location>('/locations', input)

export const updateLocation = (id: number, input: LocationInput): Promise<Location> =>
  api.put<Location>(`/locations/${id}`, input)

export const deleteLocation = (id: number): Promise<void> => api.del<void>(`/locations/${id}`)
